module.exports = __webpack_public_path__ + "static/media/instagram-w.bdd36b8e.svg";